import React from "react";
import "./SocialMediaLinks.scss";
import { FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";
function SocialMediaLinks() {
  const socialMediaLinks = [
    {
      icon: <FaFacebook />,
      link: "https://www.facebook.com/people/Lehi-Labaron/100073389434666/?mibextid=ZbWKwL",
    },
    {
      icon: <FaTiktok />,
      link: "https://www.tiktok.com/@lehiwithedp?is_from_webapp=1&sender_device=pc",
    },
    {
      icon: <FaInstagram />,
      link: "https://www.instagram.com/lehiwithedp/?igshid=OGQ5ZDc2ODk2ZA%3D%3D#",
    },
    // Agrega mas aqui
  ];
  return (
    <div>
      <ul className="social-media-list">
        {socialMediaLinks.map(({ icon, link }, index) => (
          <li key={index}>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-icon"
              aria-label="Social Media Link"
            >
              {icon}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SocialMediaLinks;
